module.exports = __webpack_public_path__ + "src/img/success.ad25e369.png";